"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_TOKEN_MUTATION = exports.REQUEST_TOKEN_MUTATION = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  mutation signInVerifyAuthenticationCode($phone: String!, $code: String!) {\n    signInVerifyAuthenticationCode(phone: $phone, code: $code) {\n      jwt\n      user {\n        name\n        id\n        email\n        phone\n        role\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  mutation SignInCreateAuthenticationCode($phone: String!) {\n    signInCreateAuthenticationCode(phone: $phone) {\n      enqueued\n      message\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var REQUEST_TOKEN_MUTATION = (0, _graphqlTag["default"])(_templateObject());
exports.REQUEST_TOKEN_MUTATION = REQUEST_TOKEN_MUTATION;
var SUBMIT_TOKEN_MUTATION = (0, _graphqlTag["default"])(_templateObject2());
exports.SUBMIT_TOKEN_MUTATION = SUBMIT_TOKEN_MUTATION;